define('deco/errorHandler',[], function(){
  return {
    onError: function(error){
     console.error(error && error.stack || error);
    }
  };
});
